module.exports = __webpack_public_path__ + "static/vregattaHome-961492c296e484b35ec16ba527967121.png";